import React, { Component } from "react";
import Breadcrumb from "./common/breadcrumb";
import CountUp from "react-countup";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  ShoppingCart,
  TrendingUp,
  Clock,
  Package,
  AlertTriangle,
  ArrowRight,
  CheckCircle,
} from "react-feather";
import { getAllProductStatsRedux } from "../actions";
import { getRecentOrders, getSingleProduct } from "../firebase/firebase.utils";
import ClipLoader from "react-spinners/ClipLoader";

const PIPELINE = [
  { key: "Processing",        label: "Processing",     color: "#818CF8", bg: "#EEF2FF", link: "/orders/Processing" },
  { key: "Confirmed",         label: "Confirmed",      color: "#F59E0B", bg: "#FFFBEB", link: "/orders/Confirmed" },
  { key: "Packing",           label: "Packing",        color: "#F97316", bg: "#FFF7ED", link: "/orders/Packing" },
  { key: "On the way",        label: "On the way",     color: "#0EA5E9", bg: "#F0F9FF", link: "/orders/On the way" },
  { key: "Delivered",         label: "Delivered",      color: "#10B981", bg: "#F0FDF4", link: "/orders/Delivered" },
  { key: "Partial Delivered", label: "Part Delivered", color: "#EAB308", bg: "#FEF9C3", link: "/orders/Partial Delivered" },
  { key: "Cancelled",         label: "Cancelled",      color: "#EF4444", bg: "#FEF2F2", link: "/orders/Cancelled" },
];


function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
}

function getInventory(p) {
  if (p.displayedVariations && p.displayedVariations.length > 0) {
    return p.displayedVariations.reduce((s, v) => s + (parseInt(v.inventory) || 0), 0);
  }
  return parseInt(p.inventory) || 0;
}

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { todayOrders: [], recentLoading: true, enriched: [], enrichedLoading: true };
  }

  async componentDidMount() {
    const { productStats, getAllProductStatsRedux: loadStats } = this.props;
    if (loadStats && (!productStats || productStats.length === 0)) {
      loadStats();
    }
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);
    const todayOrders = await getRecentOrders(500, todayStart.getTime(), todayEnd.getTime());
    this.setState({ todayOrders, recentLoading: false });
    await this.enrichStats();
  }

  enrichStats = async () => {
    const { productStats } = this.props;
    if (!productStats || productStats.length === 0) {
      this.setState({ enrichedLoading: false });
      return;
    }
    const enriched = await Promise.all(
      productStats.slice(0, 10).map(async (stat) => {
        try {
          const product = await getSingleProduct(stat.productId);
          if (!product) return { ...stat, name: "Deleted product", inventory: 0, pictures: [], deleted: true };
          const inventory = product.displayedVariations && product.displayedVariations.length > 0
            ? product.displayedVariations.reduce((sum, v) => sum + (parseInt(v.inventory) || 0), 0)
            : parseInt(product.inventory) || 0;
          return { ...stat, name: product.name, pictures: product.pictures || [], inventory, productSlug: product.id };
        } catch {
          return { ...stat, name: "Unknown", inventory: 0, pictures: [] };
        }
      })
    );
    this.setState({ enriched, enrichedLoading: false });
  };

  getDeliveryAddress(order) {
    return order.deliveryAddress || null;
  }

  getOrderTotal(order) {
    return order.totalBill || 0;
  }

  getOrderPaid(order) {
    return order.totalPaid || 0;
  }

  getTotalRevenue() {
    const { allPayments } = this.props;
    if (!allPayments) return 0;
    return allPayments.reduce((acc, p) => {
      if (p.payments) {
        p.payments.forEach((pay) => { acc += parseInt(pay.amount) || 0; });
      }
      return acc;
    }, 0);
  }

  render() {
    const { allProducts, productStats, currentAdmin } = this.props;
    const { todayOrders, recentLoading, enriched, enrichedLoading } = this.state;

    const recentOrders = todayOrders.slice(0, 5);
    const products = allProducts || [];
    const stats    = productStats || [];

    const todayTotal      = todayOrders.length;
    const processingToday = todayOrders.filter((o) => o.orderStatus === "Processing").length;
    const deliveredToday  = todayOrders.filter((o) => o.orderStatus === "Delivered").length;
    const todayBill       = todayOrders.reduce((s, o) => s + this.getOrderTotal(o), 0);
    const todayPaid       = todayOrders.reduce((s, o) => s + this.getOrderPaid(o), 0);
    const todayDue        = todayOrders.reduce((s, o) => s + Math.max(0, this.getOrderTotal(o) - this.getOrderPaid(o)), 0);

    const activeProducts  = products.filter((p) => !p.isDeleted).length;
    const outOfStock      = products.filter((p) => getInventory(p) === 0);
    const lowStock        = products.filter((p) => { const inv = getInventory(p); return inv > 0 && inv <= 5; });

    const pipeline = PIPELINE.map((stage) => ({
      ...stage,
      count: todayOrders.filter((o) => o.orderStatus === stage.key).length,
    }));

    const alertItems = [...outOfStock.slice(0, 4), ...lowStock.slice(0, 4)].slice(0, 8);
    const LOW_STOCK_THRESHOLD = 5;
    const enrichedOut = enriched.filter((p) => p.inventory <= 0);
    const enrichedLow = enriched.filter((p) => p.inventory > 0 && p.inventory <= LOW_STOCK_THRESHOLD);

    const adminName = currentAdmin ? currentAdmin.name || "Admin" : "Admin";
    const today = new Date().toLocaleDateString("en-US", {
      weekday: "long", year: "numeric", month: "long", day: "numeric",
    });

    return (
      <div style={{ background: "#F8F7FF", minHeight: "100vh" }}>
        <Breadcrumb title="Dashboard" parent="Home" />
        <div className="container-fluid" style={{ paddingTop: 8 }}>

          {/* Welcome banner */}
          <div style={{
            background: "linear-gradient(135deg, #3730A3 0%, #6D28D9 55%, #9333EA 100%)",
            borderRadius: 16,
            padding: "22px 28px",
            marginBottom: 22,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
            boxShadow: "0 10px 36px rgba(109,40,217,0.35)",
            position: "relative",
            overflow: "hidden",
          }}>
            <div style={{ position: "absolute", right: -40, top: -40, width: 160, height: 160, borderRadius: "50%", background: "rgba(255,255,255,0.06)" }} />
            <div style={{ position: "absolute", right: 60, bottom: -60, width: 120, height: 120, borderRadius: "50%", background: "rgba(255,255,255,0.04)" }} />
            <div style={{ position: "relative", zIndex: 1 }}>
              <div style={{ color: "rgba(255,255,255,0.65)", fontSize: 13, marginBottom: 4 }}>
                {getGreeting()}
              </div>
              <div style={{ color: "#fff", fontSize: 24, fontWeight: 800, letterSpacing: "-0.5px" }}>
                {adminName}
              </div>
            </div>
            <div style={{ textAlign: "right", position: "relative", zIndex: 1 }}>
              <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>{today}</div>
              <div style={{ marginTop: 6, display: "flex", gap: 8, justifyContent: "flex-end" }}>
                <span style={{ background: "rgba(255,255,255,0.15)", borderRadius: 6, padding: "3px 10px", color: "#fff", fontSize: 12, fontWeight: 600 }}>
                  {todayTotal} orders today
                </span>
              </div>
            </div>
          </div>

          {/* Today's summary pills */}
          <div className="row" style={{ marginBottom: 6 }}>
            {[
              {
                label:    "Total Orders",
                value:    todayTotal,
                prefix:   "",
                sub:      `${processingToday} processing · ${deliveredToday} delivered`,
                icon:     <ShoppingCart size={22} />,
                gradient: "linear-gradient(135deg, #4F46E5, #7C3AED)",
                shadow:   "rgba(79,70,229,0.38)",
              },
              {
                label:    "Total Bill",
                value:    todayBill,
                prefix:   "৳ ",
                sub:      "gross order value today",
                icon:     <TrendingUp size={22} />,
                gradient: "linear-gradient(135deg, #0369A1, #0EA5E9)",
                shadow:   "rgba(14,165,233,0.38)",
              },
              {
                label:    "Total Due",
                value:    todayDue,
                prefix:   "৳ ",
                sub:      "outstanding from today",
                icon:     <Clock size={22} />,
                gradient: "linear-gradient(135deg, #DC2626, #EF4444)",
                shadow:   "rgba(239,68,68,0.38)",
              },
              {
                label:    "Total Paid",
                value:    todayPaid,
                prefix:   "৳ ",
                sub:      "collected today",
                icon:     <Package size={22} />,
                gradient: "linear-gradient(135deg, #059669, #10B981)",
                shadow:   "rgba(16,185,129,0.38)",
              },
            ].map((card, i) => (
              <div key={i} className="col-xl-3 col-md-6" style={{ marginBottom: 16 }}>
                <div style={{
                  background: card.gradient,
                  borderRadius: 14,
                  padding: "20px 22px",
                  boxShadow: `0 8px 28px ${card.shadow}`,
                  color: "#fff",
                  position: "relative",
                  overflow: "hidden",
                }}>
                  <div style={{ position: "absolute", right: -16, top: -16, width: 90, height: 90, borderRadius: "50%", background: "rgba(255,255,255,0.1)" }} />
                  <div style={{ position: "absolute", right: 18, bottom: -24, width: 70, height: 70, borderRadius: "50%", background: "rgba(255,255,255,0.07)" }} />
                  <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", position: "relative", zIndex: 1 }}>
                    <div>
                      <div style={{ fontSize: 11, color: "rgba(255,255,255,0.72)", marginBottom: 8, fontWeight: 700, letterSpacing: 0.8, textTransform: "uppercase" }}>
                        {card.label}
                      </div>
                      <div style={{ fontSize: 34, fontWeight: 800, lineHeight: 1, letterSpacing: "-1px" }}>
                        {card.prefix}
                        <CountUp end={card.value} separator="," duration={1.5} />
                      </div>
                      <div style={{ fontSize: 12, color: "rgba(255,255,255,0.62)", marginTop: 8 }}>
                        {card.sub}
                      </div>
                    </div>
                    <div style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: 11,
                      width: 46,
                      height: 46,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}>
                      {card.icon}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Order pipeline */}
          <div className="card" style={{
            borderRadius: 14,
            marginBottom: 20,
            boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
            border: "1px solid #EDE9FE",
          }}>
            <div className="card-body" style={{ padding: "20px 24px" }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: "#1e293b", marginBottom: 16 }}>
                Order Pipeline
              </div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {pipeline.map((stage) => (
                  <Link
                    key={stage.key}
                    to={stage.link}
                    style={{ flex: "1 1 90px", textDecoration: "none" }}
                  >
                    <div
                      style={{
                        background: stage.bg,
                        border: `1.5px solid ${stage.color}30`,
                        borderRadius: 10,
                        padding: "12px 10px",
                        textAlign: "center",
                        transition: "transform 0.15s ease, box-shadow 0.15s ease",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = `0 6px 20px ${stage.color}25`;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      <div style={{ fontSize: 26, fontWeight: 800, color: stage.color, lineHeight: 1 }}>
                        {stage.count}
                      </div>
                      <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600, marginTop: 4, whiteSpace: "nowrap" }}>
                        {stage.label}
                      </div>
                      <div style={{ marginTop: 8, height: 4, background: "#e2e8f0", borderRadius: 2, overflow: "hidden" }}>
                        <div style={{
                          height: "100%",
                          background: stage.color,
                          borderRadius: 2,
                          width: todayTotal > 0 ? `${Math.round((stage.count / todayTotal) * 100)}%` : "0%",
                        }} />
                      </div>
                      <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 4 }}>
                        {todayTotal > 0 ? `${Math.round((stage.count / todayTotal) * 100)}%` : "0%"}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>

          {/* Recent orders + Top sellers */}
          <div className="row" style={{ marginBottom: 4 }}>

            <div className="col-xl-6" style={{ marginBottom: 20 }}>
              <div className="card" style={{
                borderRadius: 14,
                boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                border: "1px solid #EDE9FE",
                height: "100%",
              }}>
                <div className="card-body" style={{ padding: "20px 24px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, color: "#1e293b" }}>
                      Today's Orders
                      <span style={{ marginLeft: 8, fontSize: 11, fontWeight: 600, color: "#94a3b8", background: "#F1F5F9", borderRadius: 5, padding: "2px 7px" }}>
                        last 5
                      </span>
                    </div>
                    <Link
                      to="/orders/All Orders"
                      style={{ fontSize: 12, color: "#6D28D9", fontWeight: 600, display: "flex", alignItems: "center", gap: 4, textDecoration: "none" }}
                    >
                      View All <ArrowRight size={13} />
                    </Link>
                  </div>
                  <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr>
                          {["Order ID", "Delivery Address", "Items", "Total Bill"].map((h) => (
                            <th key={h} style={{
                              fontSize: 11,
                              color: "#94a3b8",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: 0.5,
                              padding: "0 10px 10px 0",
                              borderBottom: "1px solid #f1f5f9",
                              whiteSpace: "nowrap",
                              textAlign: h === "Total Bill" ? "right" : "left",
                            }}>
                              {h}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {recentLoading ? (
                          <tr>
                            <td colSpan={4} style={{ textAlign: "center", color: "#94a3b8", padding: "24px 0", fontSize: 13 }}>
                              Loading…
                            </td>
                          </tr>
                        ) : recentOrders.length === 0 ? (
                          <tr>
                            <td colSpan={4} style={{ textAlign: "center", color: "#94a3b8", padding: "24px 0", fontSize: 13 }}>
                              No orders today
                            </td>
                          </tr>
                        ) : recentOrders.map((order) => {
                          const addr = this.getDeliveryAddress(order);
                          const total = this.getOrderTotal(order);
                          const orderDate = order.date ? new Date(Number(order.date)) : null;
                          const items = order.orders || [];
                          const visibleItems = items.slice(0, 2);
                          const extraItems = items.length - visibleItems.length;
                          return (
                            <tr key={order.id} style={{ borderBottom: "1px solid #f8fafc", verticalAlign: "top" }}>

                              {/* Order ID + time */}
                              <td style={{ padding: "10px 10px 10px 0", whiteSpace: "nowrap" }}>
                                <div style={{ fontSize: 13, fontWeight: 700, color: "#4F46E5" }}>#{order.id}</div>
                                {orderDate && (
                                  <>
                                    <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 3 }}>
                                      {orderDate.toLocaleDateString()}
                                    </div>
                                    <div style={{ fontSize: 11, color: "#94a3b8" }}>
                                      {orderDate.toLocaleTimeString()}
                                    </div>
                                  </>
                                )}
                              </td>

                              {/* Delivery address card */}
                              <td style={{ padding: "8px 10px 8px 0", minWidth: 180 }}>
                                <div style={{
                                  background: "#FAF7F2",
                                  border: "1.5px solid #E8DFD0",
                                  borderRadius: 8,
                                  padding: "9px 12px",
                                  fontSize: 12,
                                  color: "#5C4A32",
                                  boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                                }}>
                                  {addr ? (
                                    <>
                                      <div style={{ fontWeight: 700, fontSize: 13, color: "#3D2B1A", marginBottom: 3 }}>
                                        {addr.fullName || "—"}
                                      </div>
                                      {addr.mobileNo && (
                                        <div style={{ fontSize: 11, color: "#7C6A55", marginBottom: 3 }}>📞 {addr.mobileNo}</div>
                                      )}
                                      <div style={{ fontSize: 11, lineHeight: "16px", color: "#5C4A32" }}>
                                        🌐 {[addr.address, addr.district, addr.division].filter(Boolean).join(", ")}
                                      </div>
                                    </>
                                  ) : <span style={{ color: "#cbd5e1" }}>—</span>}
                                </div>
                              </td>

                              {/* Items */}
                              <td style={{ padding: "8px 10px 8px 0", minWidth: 150 }}>
                                {visibleItems.length > 0 ? (
                                  <div style={{
                                    background: "#fff",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: 8,
                                    padding: "8px 10px",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                                  }}>
                                    {visibleItems.map((item, i) => {
                                      const img = item.image;
                                      const name = item.name;
                                      return (
                                        <div key={i} style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: i < visibleItems.length - 1 ? 6 : 0 }}>
                                          {img ? (
                                            <img src={img} alt="" referrerPolicy="no-referrer"
                                              onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
                                              style={{ width: 30, height: 30, borderRadius: 5, objectFit: "cover", border: "1px solid #e0e0e0", flexShrink: 0 }}
                                            />
                                          ) : null}
                                          <div style={{ width: 30, height: 30, borderRadius: 5, background: "#F1F5F9", display: img ? "none" : "flex", alignItems: "center", justifyContent: "center", fontSize: 12, color: "#CBD5E1", flexShrink: 0 }}>▦</div>
                                          <div style={{ minWidth: 0 }}>
                                            <div style={{ fontSize: 11, fontWeight: 600, color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 100 }}>{name || "—"}</div>
                                            <div style={{ fontSize: 10, color: "#6b7280" }}>Qty: {item.quantity}</div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                    {extraItems > 0 && (
                                      <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, marginTop: 4 }}>+{extraItems} more</div>
                                    )}
                                  </div>
                                ) : <span style={{ color: "#cbd5e1", fontSize: 12 }}>—</span>}
                              </td>

                              {/* Total bill */}
                              <td style={{ padding: "10px 0", fontSize: 13, fontWeight: 700, color: "#059669", whiteSpace: "nowrap", textAlign: "right" }}>
                                ৳ {total.toLocaleString()}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6" style={{ marginBottom: 20 }}>
          <div className="card" style={{ borderRadius: 14, height: "100%", boxShadow: "0 2px 16px rgba(0,0,0,0.06)", border: "1px solid #EDE9FE", overflow: "hidden" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px", borderBottom: "1px solid #f1f5f9" }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: "#1e293b" }}>Top Sold Products</div>
              <Link to="/products/physical/restock-dashboard" style={{ fontSize: 12, color: "#6D28D9", fontWeight: 600, display: "flex", alignItems: "center", gap: 4, textDecoration: "none" }}>
                Full Report <ArrowRight size={13} />
              </Link>
            </div>
            {enrichedLoading ? (
              <div style={{ textAlign: "center", padding: 48 }}>
                <ClipLoader size={28} color="#6D28D9" loading />
                <div style={{ marginTop: 10, color: "#94a3b8", fontSize: 13 }}>Loading product stats…</div>
              </div>
            ) : enriched.length === 0 ? (
              <div style={{ textAlign: "center", padding: 48, color: "#94a3b8", fontSize: 13 }}>
                No stats yet. <Link to="/products/physical/restock-dashboard" style={{ color: "#6D28D9" }}>Build from history →</Link>
              </div>
            ) : (
              <div style={{ overflowX: "auto" }}>
                <table className="table table-hover" style={{ marginBottom: 0 }}>
                  <thead>
                    <tr>
                      {["#", "Product", "Total Sold", "Current Stock", "Status"].map((h) => (
                        <th key={h} style={{ background: "linear-gradient(135deg, #4F46E5, #7C3AED)", color: "white", fontWeight: 600, fontSize: 12, padding: "12px 14px", whiteSpace: "nowrap", border: "none" }}>
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {enriched.map((p, i) => {
                      const isOut = p.inventory <= 0;
                      const isLow = p.inventory > 0 && p.inventory <= LOW_STOCK_THRESHOLD;
                      return (
                        <tr key={p.productId} style={{ background: isOut ? "#FEF2F2" : isLow ? "#FFFBEB" : "#fff" }}>
                          <td style={{ fontSize: 13, color: "#888", padding: "12px 14px", width: 40 }}>{i + 1}</td>
                          <td style={{ padding: "10px 14px", minWidth: 220 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                              {p.pictures && p.pictures[0] ? (
                                <img src={p.pictures[0]} alt="" style={{ width: 42, height: 42, borderRadius: 6, objectFit: "cover", border: "1px solid #e0e0e0", flexShrink: 0 }} />
                              ) : (
                                <div style={{ width: 42, height: 42, borderRadius: 6, background: "#f0f0f0", flexShrink: 0 }} />
                              )}
                              <div style={{ fontSize: 13, fontWeight: 600, color: "#1e293b", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", maxWidth: 200 }}>
                                {p.name}
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: "12px 14px", fontWeight: 700, fontSize: 14, color: "#4F46E5", whiteSpace: "nowrap" }}>
                            {p.totalSold > 0 ? `${p.totalSold} pc` : "—"}
                          </td>
                          <td style={{ padding: "12px 14px", fontWeight: 700, fontSize: 14, whiteSpace: "nowrap", color: isOut ? "#DC2626" : isLow ? "#D97706" : "#1e293b" }}>
                            {p.inventory} pc
                          </td>
                          <td style={{ padding: "12px 14px", whiteSpace: "nowrap" }}>
                            {isOut ? (
                              <span style={{ background: "#DC2626", color: "white", borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>Out of Stock</span>
                            ) : isLow ? (
                              <span style={{ background: "#D97706", color: "white", borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>Low Stock</span>
                            ) : (
                              <span style={{ background: "#059669", color: "white", borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>In Stock</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
            </div>
          </div>

          {/* Stock alerts */}
          {alertItems.length > 0 && (
            <div className="card" style={{
              borderRadius: 14,
              marginBottom: 20,
              boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
              border: "1.5px solid #FCA5A5",
            }}>
              <div className="card-body" style={{ padding: "20px 24px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <AlertTriangle size={16} color="#EF4444" />
                    <span style={{ fontWeight: 700, fontSize: 15, color: "#1e293b" }}>Stock Alerts</span>
                    <span style={{ background: "#FEE2E2", color: "#991B1B", borderRadius: 5, padding: "1px 7px", fontSize: 11, fontWeight: 700 }}>
                      {outOfStock.length + lowStock.length} items
                    </span>
                  </div>
                  <Link
                    to="/products/physical/restock-dashboard"
                    style={{ fontSize: 12, color: "#6D28D9", fontWeight: 600, textDecoration: "none" }}
                  >
                    Restock Dashboard →
                  </Link>
                </div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {alertItems.map((p) => {
                    const inv = getInventory(p);
                    const isOut = inv === 0;
                    return (
                      <Link
                        key={p.id}
                        to={`/products/physical/add-product/${p.id}`}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          background: isOut ? "#FEF2F2" : "#FFFBEB",
                          border: `1.5px solid ${isOut ? "#FCA5A5" : "#FCD34D"}`,
                          borderRadius: 8,
                          padding: "8px 12px",
                          textDecoration: "none",
                          flex: "0 0 auto",
                          maxWidth: 220,
                          transition: "transform 0.15s ease",
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; }}
                        onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; }}
                      >
                        {p.pictures && p.pictures[0] ? (
                          <img src={p.pictures[0]} alt="" style={{ width: 32, height: 32, borderRadius: 5, objectFit: "cover", flexShrink: 0 }} />
                        ) : (
                          <div style={{ width: 32, height: 32, borderRadius: 5, background: "#f0f0f0", flexShrink: 0 }} />
                        )}
                        <div>
                          <div style={{ fontSize: 12, fontWeight: 600, color: "#1e293b", maxWidth: 150, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {p.name}
                          </div>
                          <div style={{ fontSize: 11, color: isOut ? "#DC2626" : "#D97706", fontWeight: 700, marginTop: 1 }}>
                            {isOut ? "Out of Stock" : `${inv} pc left`}
                          </div>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>
          )}

          {/* Delivery success strip */}
          {deliveredToday > 0 && (
            <div style={{
              background: "linear-gradient(135deg, #ECFDF5, #D1FAE5)",
              border: "1.5px solid #6EE7B7",
              borderRadius: 12,
              padding: "14px 20px",
              marginBottom: 20,
              display: "flex",
              alignItems: "center",
              gap: 12,
            }}>
              <CheckCircle size={20} color="#059669" />
              <div>
                <span style={{ fontWeight: 700, color: "#065F46", fontSize: 14 }}>
                  {deliveredToday} orders delivered today
                </span>
                <span style={{ color: "#047857", fontSize: 13, marginLeft: 8 }}>
                  · {todayTotal > 0 ? Math.round((deliveredToday / todayTotal) * 100) : 0}% of today's orders
                </span>
              </div>
            </div>
          )}

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({

  allPayments:  state.payments.payments,
  allAdmins:    state.admins.admins,
  allProducts:  state.products.products,
  currentAdmin: state.admins.currentAdmin,
  productStats: state.products.productStats || [],
});

export default connect(mapStateToProps, { getAllProductStatsRedux })(Dashboard);
